<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>


    <ng-template pTemplate="header">CREAR MODIFICAR PARTICIPANTE</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="redirectParent()"></button>
        </ng-template>
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_place_where_provide}}</span>
                        <span class="p-text-bold">{{form0Detail != null ? form0Detail.churchAdress.name  : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_service}}</span>
                        <span class="p-text-bold">{{form0Detail != null ? form0Detail.serName : ""}}	</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_schedule}}</span>
                        <span class="p-text-bold">{{form0Detail != null ? form0Detail.fromTime : ""}} - {{form0Detail != null ? form0Detail.toTime : ""}}</span>
                    </div>
                    <div class="p-mr-2 p-mb-2">
                        <button pButton pRipple type="button" icon="pi pi-plus" label="{{lbl_save}}" class="p-button-raised p-button-success" (click)="saveParticipant()"></button>
                    </div>
                   
                </p-panel>
            </div>
        </div>


        <div class="p-grid">
                    
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <h5>Datos del Participante</h5>
                    <div class="p-fluid">
    
                        <div class="p-field p-grid p-text-bold">
                            <label for="firstname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_id}}</label>
                            <div class="p-col-12 p-md-10">
                                <span class="p-text-bold">{{ participantView ? (participantView.particiId | number) : "" }}</span>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_name}} *</label>
                            <div class="p-col-12 p-md-10">
                                <input type="text" pInputText id="name" [(ngModel)]="participantView.name" required autofocus />
                            <small class="p-error" *ngIf="submitted && !participantView.name">Se requiere nombre</small>
                            </div>
                        </div>
    
                        <div class="p-field p-grid">
                            <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_lastName}} *</label>
                            <div class="p-col-12 p-md-10">
                                <input type="text" pInputText id="name" [(ngModel)]="participantView.lastName" required autofocus />
                                <small class="p-error" *ngIf="submitted && !participantView.lastName">Se requiere apellidos</small>
                            </div>
                        </div>
                
                        <div class="p-field p-grid">
                            <label for="dateformat" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_birth_date}} *</label>
                            <div class="p-col-12 p-md-10">
                                <p-calendar [(ngModel)]="birthday" dateFormat="dd-MM-yy"   [showIcon]="true"  [maxDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true" inputId="navigators" yearRange="1900:2030"></p-calendar>
                                <small class="p-error" *ngIf="submitted && !birthday">Se requiere Fecha Nacimiento</small>
                            </div>
                        </div>
    
                        <div class="p-field p-grid">
                            <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_email}}</label>
                            <div class="p-col-12 p-md-10">
                                <input type="text" pInputText id="name" [(ngModel)]="participantView.email" required autofocus />
                                <!--small class="p-error" *ngIf="submitted && !userView.email">Se requiere email</small-->
                                <small class="p-error" *ngIf="submitted && !mailValid">Formato incorrecto Email</small>
                            </div>
                        </div>
    
                        <div class="p-field p-grid">
                            <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_cell_phone}}</label>
                            <div class="p-col-12 p-md-10">
                                <p-inputNumber [(ngModel)]="participantView.mobPhon" mode="decimal" inputId="withoutgrouping" [useGrouping]="false">
                                </p-inputNumber>
                            </div>
                        </div>
    
                        <div class="p-field p-grid">
                            <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_gender}} *</label>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown  [virtualScroll]="true" [options]="listGender" [(ngModel)]="selectedGender"  optionLabel="descrip" [showClear]="true" placeholder="{{lbl_select}} {{lbl_gender}}"></p-dropdown>
                                <small class="p-error" *ngIf="submitted && !selectedGender">Se requiere {{lbl_select}} {{lbl_gender}}</small>
                            </div>
                        </div>

                        <div class="p-field p-grid">
                            <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_language}} *</label>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown  [virtualScroll]="true" [options]="listLanguage" [(ngModel)]="selectedLanguage"  optionLabel="descrip" [showClear]="true" placeholder="{{lbl_select}} {{lbl_language}}"></p-dropdown>
                                <small class="p-error" *ngIf="submitted && !selectedLanguage">Se requiere seleccionar Idioma</small>
                            </div>
                        </div>
    
                        
    
                    </div>
                </div>
            </div>
            
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <h5>{{lbl_address}}</h5>
                        <div class="p-fluid">
                            <div class="p-field p-grid">
                                <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_city_states}} *</label>
                                <div class="p-col-12 p-md-10">
                                    <p-dropdown  [virtualScroll]="true" [options]="listState" [(ngModel)]="selectedState" [filter]="true"  optionLabel="descrip" [showClear]="true" placeholder="{{lbl_select}} {{lbl_state}}"></p-dropdown>
                                    <small class="p-error" *ngIf="submitted && !selectedState">Se requiere seleccionar Estado/Depto</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_county_city}} *</label>
                                <div class="p-col-12 p-md-10">
                                    <input id="lastname4" type="text" [(ngModel)]="address.city" pInputText>
                                    <small class="p-error" *ngIf="submitted && !address.city">Se requiere información</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_neightborhood}} *</label>
                                <div class="p-col-12 p-md-10">
                                    <input id="lastname4" type="text" [(ngModel)]="address.neight" pInputText>
                                    <small class="p-error" *ngIf="submitted && !address.neight">Se requiere información</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_zip_code}}</label>
                                <div class="p-col-12 p-md-10">
                                    <p-inputNumber [(ngModel)]="address.zipCode" mode="decimal" inputId="withoutgrouping" [useGrouping]="false">
                                    </p-inputNumber>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{lbl_street_and_number}}</label>
                                <div class="p-col-12 p-md-10">
                                    <input id="lastname4" type="text" [(ngModel)]="address.street" pInputText>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>

    </div>

</p-fieldset>